<template>
  <v-card outlined tile>
    <v-card-text>
      <v-container fluid class="ma-0 pa-0">
        <v-card outlined>
          <v-row>
            <v-col class="mt-0 mb-0">
              <v-card-text v-if="alermHistoryMixin_isDevice">
                {{ alermHistoryMixin_deviceName }}
              </v-card-text>
            </v-col>
          </v-row>
          <v-row>
            <v-col class="mt-0 mb-0">
              <v-card-text v-if="alermHistoryMixin_optionalInfo">
                {{ $t(`customerSMachineNo`) }}<span class="ml-5">{{ alermHistoryMixin_optionalInfo }}</span>
              </v-card-text>
            </v-col>
            <v-col class="mt-0 mb-0">
              <v-card-actions class="float-right">
                <v-btn
                  @click="alermHistoryMixin_filterEventLevelE(max_number)"
                  :color="alermHistoryMixin_searchObject.eventLevelE ? 'primary' : 'grey lighten-2'"
                  :dark="alermHistoryMixin_searchObject.eventLevelE"
                  class="mx-0 px-0 rounded-r-0"
                  depressed
                  >E</v-btn
                >
                <v-btn
                  @click="alermHistoryMixin_filterEventLevelC(max_number)"
                  :color="alermHistoryMixin_searchObject.eventLevelC ? 'primary' : 'grey lighten-2'"
                  :dark="alermHistoryMixin_searchObject.eventLevelC"
                  class="mx-0 px-0 rounded-l-0 rounded-r-0"
                  depressed
                  >C</v-btn
                >
                <v-btn
                  @click="alermHistoryMixin_filterEventLevelM(max_number)"
                  :color="alermHistoryMixin_searchObject.eventLevelM ? 'primary' : 'grey lighten-2'"
                  :dark="alermHistoryMixin_searchObject.eventLevelM"
                  class="mx-0 px-0 rounded-l-0"
                  depressed
                  >M</v-btn
                >

                <v-btn @click="getNextAlermHistory" color="primary">
                  <v-icon class="material-symbols-outlined" large> format_list_bulleted_add </v-icon>
                </v-btn>
                <v-btn
                  @click="alermHistoryMixin_filterRepaired(max_number)"
                  :color="alermHistoryMixin_searchObject.repaired ? 'primary' : 'grey lighten-2'"
                  :dark="alermHistoryMixin_searchObject.repaired"
                  depressed
                  ><v-icon>mdi-reload</v-icon></v-btn
                >
              </v-card-actions>
            </v-col>
          </v-row>
          <v-card-text>
            <v-data-table
              height="70vh"
              fixed-header
              dense
              :headers="alermHistoryMixin_headers"
              :items="alermHistoryMixin_items"
              :items-per-page="max_number"
              hide-default-footer
              item-key="id"
              @click:row="alermHistoryMixin_clickRow"
              :item-class="alermHistoryMixin_alermHighlight"
              :loading="alermHistoryMixin_loading"
              class="v-data-table-outlined"
            >
              <template v-slot:[`item.name_locale`]="{ item }">
                <v-img
                  v-if="item.event_level === '1'"
                  src="@/assets/maintenance.png"
                  width="20"
                  height="20"
                  contain
                  class="d-inline-block"
                ></v-img>
                <v-img
                  v-if="item.event_level === '2'"
                  src="@/assets/caution.png"
                  width="20"
                  height="20"
                  contain
                  class="d-inline-block mx-0 px-0"
                ></v-img>
                <v-img
                  v-if="item.event_level === '3'"
                  src="@/assets/emergency.png"
                  width="20"
                  height="20"
                  contain
                  class="d-inline-block"
                ></v-img>
                {{ item[`name_locale${localeId}`] }}
              </template>
              <template v-slot:[`item.device_name_locale`]="{ item }">
                <router-link
                  target="_blank"
                  :to="{ name: 'CompressorInfo', params: { model_id: item.model_id, serial_no: item.serial_no } }"
                >
                  {{ item[`device_name_locale${localeId}`] }}
                </router-link>
              </template>
              <template v-slot:[`item.device_group_name_locale`]="{ item }">
                <router-link
                  target="_blank"
                  :to="{ name: 'HomeConsumer', params: { device_group_id: item.device_group_id } }"
                >
                  {{ item[`device_group_name_locale${localeId}`] }}
                </router-link>
              </template>
            </v-data-table>
          </v-card-text>
        </v-card>
      </v-container>
    </v-card-text>
  </v-card>
</template>
<script>
  import { mapGetters } from 'vuex';
  import { alermHistoryMixin } from '@/utils/dashbord.js';

  export default {
    name: 'Table',
    components: {},
    mixins: [alermHistoryMixin('alermHistoryMixin')],
    data: () => ({
      max_number: 100,
    }),
    props: {
      value: String,
    },
    filters: {},
    watch: {
      async groupId() {
        this.alermHistoryMixin_groupId = this.groupId;
        this.alermHistoryMixin_compressors = await this.alermHistoryMixin_getGroups(
          this.alermHistoryMixin_deviceGroupId,
          this.alermHistoryMixin_groupId
        );

        this.alermHistoryMixin_getAlermHistory(true, this.max_number);
      },
    },
    computed: {
      ...mapGetters('auth', ['user_info']),
      localeId() {
        switch (this.$i18n.locale) {
          case 'en':
            return 1;
          case 'ja':
            return 2;
          case 'zh':
            return 3;
        }
        return 2;
      },
      groupId() {
        return this.$props.value;
      },
    },
    async created() {
      // 入力パラメータを保持
      this.alermHistoryMixin_deviceGroupId = this.$route.params.device_group_id;
      this.alermHistoryMixin_modelId = undefined;
      this.alermHistoryMixin_serialNo = undefined;
      this.alermHistoryMixin_groupId = undefined;
      this.alermHistoryMixin_compressors = await this.alermHistoryMixin_getGroups(
        this.alermHistoryMixin_deviceGroupId,
        undefined
      );
      this.alermHistoryMixin_getAlermHistory(true, this.max_number);
    },
    methods: {
      async getNextAlermHistory() {
        this.max_number += 100;
        this.alermHistoryMixin_getAlermHistory(false, this.max_number);
      },
    },
  };
</script>
<style scoped></style>
